'use client'
import { DARK_MAP_CUSTOMIZATION, LIGHT_MAP_CUSTOMIZATION, MAP_CAMERA, MAP_LOCATION } from '@/config/map.config'
import { FooterBranch } from '@/redux/services/footerApi'
import { useMediaQuery } from 'usehooks-ts'
import { YMap, YMapDefaultFeaturesLayer, YMapDefaultSchemeLayer, YMapMarker } from 'ymap3-components'

const getCoords = (data: FooterBranch[]) => {
    if (!data) return []

    return data.map(({ id, coors }) => {
        const coords = coors
            .split(', ')
            .map(v => Number(v))
            .reverse()

        return { id, coords }
    })
}

export type MapTheme = 'dark' | 'light'

interface IProps {
    branches: FooterBranch[]
    theme?: MapTheme
    onDropdownToggle: (id: number) => () => void
}

const CUSTOMIZATION_BY_THEME = {
    dark: DARK_MAP_CUSTOMIZATION,
    light: LIGHT_MAP_CUSTOMIZATION
}

const Map: React.FC<IProps> = ({ branches, theme = 'dark', onDropdownToggle }) => {
    const coords = getCoords(branches)
    const customization = CUSTOMIZATION_BY_THEME[theme]

    const handleMarkerClick = (id: number) => () => {
        onDropdownToggle(id)()
    }

    const isTablet = useMediaQuery('(screen and  max-width: 1040px)')

    return (
        <div className='footer__map map'>
            <YMap
                behaviors={isTablet ? undefined : ['drag']}
                location={MAP_LOCATION}
                mode='vector'
                camera={MAP_CAMERA}
            >
                <YMapDefaultSchemeLayer
                    visible
                    customization={customization}
                />
                <YMapDefaultFeaturesLayer />

                {coords.map(({ id, coords }, index) => (
                    <YMapMarker
                        key={index}
                        coordinates={coords}
                    >
                        <button
                            onClick={handleMarkerClick(id)}
                            className='map__marker'
                        >
                            <svg
                                width='20'
                                height='25'
                                viewBox='0 0 20 25'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                            >
                                <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M10 24.1667C10 24.1667 20 15.8683 20 10.2226C20 4.5768 15.5228 0 10 0C4.47715 0 0 4.5768 0 10.2226C0 15.8683 10 24.1667 10 24.1667ZM9.99998 14.3977C12.7189 14.3977 14.9231 12.1936 14.9231 9.47467C14.9231 6.75573 12.7189 4.5516 9.99998 4.5516C7.28104 4.5516 5.0769 6.75573 5.0769 9.47467C5.0769 12.1936 7.28104 14.3977 9.99998 14.3977Z'
                                    fill='url(#paint0_linear_426_31492)'
                                />
                                <defs>
                                    <linearGradient
                                        id='paint0_linear_426_31492'
                                        x1='15.9669'
                                        y1='8.97619'
                                        x2='-0.360417'
                                        y2='9.374'
                                        gradientUnits='userSpaceOnUse'
                                    >
                                        <stop stop-color='#FEAA9F' />
                                        <stop
                                            offset='1'
                                            stop-color='#FEC2BA'
                                        />
                                    </linearGradient>
                                </defs>
                            </svg>
                        </button>
                    </YMapMarker>
                ))}
            </YMap>
        </div>
    )
}

export default Map
